import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SIDEMENU_DEFS } from '../../shared/navigation/menu-defs';
import { routes as APP_ROUTES } from '../../app.routes';
import { normalizeRole } from '../system-roles';

export interface RoleRoute {
  role: string;
  defaultRoute: string;
  allowedRoutes: string[];
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  // Define default landing pages and allowed routes per role
  private roleRoutes: RoleRoute[] = [
    {
      role: 'hospitaladmin',
      defaultRoute: '/app/dashboard',
      allowedRoutes: [
        '/app/dashboard',
        '/app/services-details',
        '/app/add-service-details',
        '/app/healthcare-services',
        '/app/practitioners',
        '/app/practitioners/*',
        '/app/schedules/admin-calendar/*',
        '/app/practitioner-register',
        '/app/medicine-stock',
        '/app/admission-location',
        '/app/admission-location/add',
        '/app/supply-stock',
        '/app/appointments',
        '/app/appointments/**',
        '/app/request-documents',
        '/app/request-documents/**',
        '/app/schedules', '/app/schedules/admin-calendar/*',
        '/app/hospital-remote-doctors',
        '/app/schedules',
        '/app/schedules/**',
        '/app/schedule',
        '/app/duty-roster',
        '/app/tasks',
        '/app/org',
        '/app/company-settings',
        '/app/profile',
        '/events',
        '/events/**',
        '/documentation/**',
         '/documentation/',
        '/app/profit-margins'
      ]
    },
    {
      role: 'superadmin',
      defaultRoute: '/app/dashboard',
      allowedRoutes: ['/app/**', '/app/organizations', '/app/leaderboard']
    },
    {
      role: 'practitioner',
      defaultRoute: '/app/patients',
      allowedRoutes: [
        '/app/patients',
        '/app/patients/**',
        '/app/appointments',
        '/app/appointments/**',
        '/app/tests-requests',
        '/app/observation-reference-ranges',
        '/app/medicine-requests',
        '/app/dashboard',
        '/app/calendar',
        '/app/schedules', '/app/schedules/admin-calendar/*',
        '/app/tasks',
        '/app/profile',
        '/app/patient-bills',
        '/app/patient-bills/**',
            '/documentation/**',
         '/documentation/',
      ]
    },
    {
      role: 'doctor',
      defaultRoute: '/app/patients',
      allowedRoutes: [
        '/app/patients',
        '/app/patients/**',
        '/app/appointments',
        '/app/appointments/**',
        '/app/referral-requests',
        '/app/referral-requests/**',
        '/app/tests-requests',
        '/app/request-documents',
        '/app/request-documents/**',
        '/app/admitted-patients',
        '/app/admitted-patients/**',
        '/app/medicine-requests',
        '/app/dashboard',
        '/app/calendar',
          '/app/schedules', '/app/schedules/schedules-list', '/app/schedules/admin-calendar/*',
        '/app/schedule',
        '/app/duty-roster',
        '/app/tasks',
        '/app/profile',
        '/app/patient-bills',
        '/app/patient-bills/**',
        '/app/diagnostic-reports',
        '/app/invoice',
        '/app/invoice/**',
            '/documentation/**',
         '/documentation/',
        '/app/service-requests/**',
        '/app/triage',
        '/app/triage/**'
      ]
    },
    {
      role: 'primaryhealthcareprovider',
      defaultRoute: '/app/patients',
      allowedRoutes: [
        '/app/patients',
        '/app/patients/**',
        '/app/appointments',
        '/app/appointments/**',
        '/app/referral-requests',
        '/app/referral-requests/**',
        '/app/tests-requests',
        '/app/request-documents',
        '/app/request-documents/**',
        '/app/admitted-patients',
        '/app/admitted-patients/**',
        '/app/medicine-requests',
        '/app/dashboard',
        '/app/calendar',
          '/app/schedules', '/app/schedules/schedules-list', '/app/schedules/admin-calendar/*',
        '/app/schedule',
        '/app/tasks',
        '/app/profile',
        '/app/patient-bills',
        '/app/patient-bills/**',
        '/app/diagnostic-reports',
        '/app/invoice',
        '/app/invoice/**',
            '/documentation/**',
         '/documentation/',
        '/app/service-requests/**',
      ]
    },
    {
      role: 'alliedhealthprofessional',
      defaultRoute: '/app/patients',
      allowedRoutes: [
        '/app/patients',
        '/app/patients/**',
        '/app/appointments',
        '/app/appointments/**',
        '/app/services-details',
        '/app/services-details/**',
        '/app/add-service-details',
        '/app/add-service-details/**',
        '/app/tests-requests',
        '/app/request-documents',
        '/app/request-documents/**',
        '/app/service-requests',
        '/app/service-requests/**',
        '/app/medicine-requests',
        '/app/dashboard',
        //specimen
        '/app/specimens',
        '/app/calendar',
          '/app/schedules', '/app/schedules/schedules-list', '/app/schedules/admin-calendar/*',
        '/app/schedule',
        '/app/tasks',
        '/app/profile',
        '/app/patient-bills',
            '/documentation/**',
         '/documentation/',
        '/app/patient-bills/**'
      ]
    },
    {
      role: 'healthcareassistant',
      defaultRoute: '/app/dashboard',
      allowedRoutes: [
        '/app/dashboard',
        '/app/patients',
        '/app/patients/**',

        '/app/service-requests',
        '/app/service-requests/**',
        '/app/request-documents',
        '/app/request-documents/**',
        '/app/appointments',
        '/app/referral-requests',
        '/app/referral-requests/**',
        '/app/tasks',
        '/app/calendar',
          '/app/schedules', '/app/schedules/schedules-list', '/app/schedules/admin-calendar/*',
        '/app/schedule',
        '/app/duty-roster',
        '/app/profile',
        '/app/admitted-patients',
            '/documentation/**',
         '/documentation/',
        '/app/admitted-patients/**',
        '/app/triage',
        '/app/triage/**'
      ]
    },
    {
      role: 'nursemidwife',
      defaultRoute: '/app/dashboard',
      allowedRoutes: [
        '/app/dashboard',
        '/app/patients',
        '/app/patients/**',
        '/app/service-requests',
        // '/app/service-requests/**',
         '/app/patients/*/service-requests/procedure',
           '/app/patients/*/service-requests/procedure/**',
          '/app/patients/*/service-requests/surgery',
           '/app/patients/*/service-requests/surgery/**',
           '/app/patients/*/service-requests/observation',
            '/app/patients/*/service-requests/observation/**',
            '/app/patients/*/service-requests/others',
               '/app/patients/*/service-requests/others/**',
          '/app/service-requests/procedure',
           '/app/service-requests/procedure/**',
          '/app/service-requests/surgery',
           '/app/service-requests/surgery/**',
           '/app/service-requests/observation',
            '/app/service-requests/observation/**',
            '/app/service-requests/others',
               '/app/service-requests/others/**',
          
        '/app/request-documents',
        '/app/request-documents/**',
        '/app/medicine-requests',
        '/app/appointments',
        '/app/referral-requests',
        '/app/referral-requests/**',
        '/app/tasks',
        '/app/calendar',
          '/app/schedules', '/app/schedules/schedules-list', '/app/schedules/admin-calendar/*',
        '/app/schedule',
        '/app/profile',
        '/app/admitted-patients',
        '/app/admitted-patients/**',
        '/app/invoice',
        '/app/invoice/**',
        '/app/patient-bills',
            '/documentation/**',
         '/documentation/',
        '/app/patient-bills/**',
        '/app/triage',
        '/app/triage/**'
      ]
    },
    {
      role: 'healthcareadmin',
      defaultRoute: '/app/dashboard',
      allowedRoutes: [
        '/app/receptionist-dashboard',
        '/app/patient-registration',
        '/app/patient-registration/**',
        '/app/patient-registration-data',
        '/app/appointments',
        '/app/appointments/**',
        '/app/request-documents',
        '/app/request-documents/**',
        '/app/dashboard',
        '/app/profile',
        '/app/schedules', '/app/schedules/admin-calendar/*',
            '/documentation/**',
         '/documentation/',
        '/app/schedules',
        '/app/triage',
        '/app/triage/**'
      ]
    },
    {
      role: 'lab',
      defaultRoute: '/app/tests-requests',
      allowedRoutes: [
        '/app/tests-requests',
        '/app/observation-reference-ranges',
        '/app/specimens',
        '/app/lab-supplies',
        '/app/services-details',
        '/app/services-details/**',
        '/app/add-service-details',
        '/app/add-service-details/**',
        '/app/tasks',
        '/app/profile',
        '/app/patients',
        '/app/patients/*/service-requests/lab-tests',
        '/app/patients/*/service-requests/lab-tests/**',

        '/app/service-requests/lab-tests',
        '/app/service-requests/lab-tests/**',

        '/app/dashboard',
        '/app/schedules', '/app/schedules/admin-calendar/*',
            '/documentation/**',
         '/documentation/',
        '/app/schedules'
      ]
    },
    {
      role: 'labtechnician',
      defaultRoute: '/app/tests-requests',
      allowedRoutes: [
        '/app/tests-requests',
        '/app/observation-reference-ranges',
        '/app/specimens',
        '/app/lab-supplies',
        '/app/services-details',
        '/app/services-details/**',
        '/app/add-service-details',
        '/app/add-service-details/**',
        '/app/patients',
        '/app/patients/**',
        '/app/patients/*/service-requests/lab-tests',
        '/app/patients/*/service-requests/lab-tests/**',
        '/app/dashboard',
        '/app/schedules', '/app/schedules/admin-calendar/*',
        //supply-stock
        '/app/supply-stock',

        '/app/service-requests/lab-tests',
        '/app/service-requests/lab-tests/**',
        '/app/tasks',
            '/documentation/**',
         '/documentation/',
        '/app/profile'
      ]
    },
    {
      role: 'pharmacy',
      defaultRoute: '/app/pharmacy-dashboard',
      allowedRoutes: [
        '/app/pharmacy-dashboard',
        '/app/medicine-requests',
        '/app/medicine-stock',
        '/app/medication-dispense',
        '/app/request-documents',
        '/app/request-documents/**',
        '/app/tasks',
        '/app/profile',
        '/app/patients',
        '/app/dashboard',
        '/app/schedules', '/app/schedules/admin-calendar/*',
            '/documentation/**',
         '/documentation/',
        '/app/schedules'
      ]
    },
    {
      role: 'pharmacist',
      defaultRoute: '/app/pharmacy-dashboard',
      allowedRoutes: [
        '/app/pharmacy-dashboard',
        '/app/medicine-requests',
        '/app/medicine-stock',
        '/app/medication-dispense',
        '/app/request-documents',
        '/app/request-documents/**',
        '/app/tasks',
        '/app/profile',
        '/app/patients',
        '/app/dashboard',
        '/app/schedules', '/app/schedules/admin-calendar/*',
            '/documentation/**',
         '/documentation/',
        '/app/schedules'
      ]
    },
    {
      role: 'cashier',
      defaultRoute: '/app/invoice',
      allowedRoutes: [
        '/app/claims',
        '/app/invoice',
        '/app/invoice/**',
        '/app/charges',
        '/app/charges/**',
        '/app/patient-bills',
        '/app/patient-bills/**',
        '/app/profile',
        '/app/dashboard',
        '/app/appointments',
        '/app/medicine-requests',
        '/app/tests-requests',

        '/app/service-requests/**',
        '/app/tasks',
        '/app/profit-margins',
            '/documentation/**',
         '/documentation/',
        '/app/profit-margins/**'
      ]
    },
    {
      role: 'patient',
      defaultRoute: '/app/profile',
      allowedRoutes: [
        '/app/profile',
        '/app/appointments',
        '/app/appointments/**',
        '/app/invoice',
        '/app/invoice/**',
            '/documentation/**',
         '/documentation/',
        '/app/patients/**'
      ]
    },
    {
  role: 'globaleventmanager',
  defaultRoute: '/app/global-event-manager-dashboard',
  allowedRoutes: [
    '/app/global-event-manager-dashboard',
    '/app/dashboard',
    '/events',
    '/events/**',
    '/app/profile',
    '/documentation/**',
    '/documentation/'
  ]
},
    {
  role: 'eventmanager',
  defaultRoute: '/app/eventmanager-dashboard',
  allowedRoutes: [
    '/app/dashboard',
    '/events',
    '/events/**',
    '/app/profile',
    '/documentation/**',
    '/documentation/'
  ]
},
    {
      role: 'remotedoctor',
      defaultRoute: '/app/dashboard',
      allowedRoutes: [
        '/app/dashboard',
        '/app/schedules', '/app/schedules/schedules-list', '/app/schedules/admin-calendar/*',
        '/app/schedule',
        '/app/calendar',
        '/app/appointments',
        '/app/appointments/**',
        '/app/consultation-requests',
        '/app/consultation-requests/**',
        '/app/duty-roster',
        '/app/patients',
        '/app/patients/**',
        '/app/request-documents',
        '/app/request-documents/**',
        '/app/service-requests/**',
        '/app/profile',
        '/app/tasks',
        '/app/invoice',
        '/app/invoice/**',
        '/app/patient-bills',
        '/app/patient-bills/**',
            '/documentation/**',
         '/documentation/',
        '/app/remote-doctor/my-hospitals',
        '/app/triage',
        '/app/triage/**'
      ]
    }
  ];

  constructor(private router: Router) {
    // Derive allowed routes from sidemenu definitions and application routes.
    try {
      const sidemenuLinksByRole: Record<string, Set<string>> = {};
      const allSidemenuLinks = new Set<string>();

      for (const role of Object.keys(SIDEMENU_DEFS)) {
        const def = SIDEMENU_DEFS[role];
        const links = new Set<string>();
        (def.primary_menu || []).forEach((m: any) => m.link && links.add(m.link));
        (def.grouped_menu || []).forEach((group: any[]) => {
          const items = group?.[1] || [];
          (items || []).forEach((it: any) => it.link && links.add(it.link));
        });
        sidemenuLinksByRole[role] = links;
        for (const l of links) allSidemenuLinks.add(l);
      }

      const collectPaths = (rs: any[], parent = ''): string[] => {
        const out: string[] = [];
        for (const r of rs || []) {
          const seg = (r.path || '').toString().trim();
          const combined = parent && seg ? `${parent}/${seg}` : parent || seg;
          if (combined) out.push('/' + combined.replace(/^\//, '').replace(/\/\//g, '/'));
          if (Array.isArray(r.children)) {
            out.push(...collectPaths(r.children, combined));
          }
        }
        return out;
      };

      const appRoutePaths = new Set(collectPaths(APP_ROUTES as any[]));
      const nonSidemenuRoutes: string[] = [];
      for (const p of Array.from(appRoutePaths)) {
        if (!allSidemenuLinks.has(p)) nonSidemenuRoutes.push(p);
      }
      console.log('non side  menu routes:', nonSidemenuRoutes);
      console.log('sidemenu links by role:', sidemenuLinksByRole);
      //all
      console.log('all sidemenu links:', allSidemenuLinks);
      // Merge into configured roleRoutes: include sidemenu links for the role and allow any non-sidemenu route to all roles
      this.roleRoutes = this.roleRoutes.map((rr) => {
        const roleLower = rr.role.toLowerCase();
        const sidemenuLinks = sidemenuLinksByRole[roleLower] ? Array.from(sidemenuLinksByRole[roleLower]) : [];
        const sharedAccessRoutes = [
          '/app/messaging',
          '/app/messaging/**',
          '/app/notifications',
          '/app/notifications/**',
          '/app/zoom-meetings',
          '/app/zoom-meetings/**',
          '/app/patients/*/zoom-meeting',
          '/app/patients/*/zoom-meeting/**'
        ];
        const combined = new Set<string>([...(rr.allowedRoutes || []), ...sidemenuLinks, ...sharedAccessRoutes]);
        return { ...rr, allowedRoutes: Array.from(combined) };
      });
    } catch (e) {
      // if dynamic derivation fails, keep the static roleRoutes defined above
      console.warn('NavigationService: failed to derive routes from sidemenu/app routes', e);
    }
  }

  /**
   * Get the default route for a given role
   */
  getDefaultRouteForRole(role: string): string {
    const roleLower = normalizeRole(role);
    const roleConfig = this.roleRoutes.find(r =>
      normalizeRole(r.role) === roleLower
    );

    const defaultRoute = roleConfig?.defaultRoute || '/app/dashboard';
    return defaultRoute;
  }

  /**
   * Navigate user to their default page based on role
   */
  navigateToRoleDefaultPage(role: string, triedUrl?: string): void {
    // If there's a tried URL and it's allowed for this role, go there
    if (triedUrl && this.isRouteAllowedForRole(triedUrl, role)) {
      this.router.navigate([triedUrl]);
      return;
    }

    // Otherwise, go to role's default page
    const defaultRoute = this.getDefaultRouteForRole(role);
    this.router.navigate([defaultRoute]);
  }

  /**
   * Check if a route is allowed for a role.
   * Supports explicit route matches as well as segment-aware wildcards:
   * - '*' matches one path segment
   * - '**' matches zero or more path segments
   */
  isRouteAllowedForRole(route: string, role: string): boolean {
    const roleLower = normalizeRole(role);

    // SuperAdmin can access everything across the platform
    if (roleLower === 'superadmin') {
      return true;
    }

    const roleConfig = this.roleRoutes.find(r =>
      normalizeRole(r.role) === roleLower
    );

    if (!roleConfig) {
      console.warn('⚠️ No role config found for role:', role);
      return false;
    }

    const normalizedRoute = this.normalizeRoute(route);

    return roleConfig.allowedRoutes.some((allowedRoute) =>
      this.matchesRoutePattern(normalizedRoute, this.normalizeRoute(allowedRoute))
    );
  }

  private normalizeRoute(route: string): string {
    const value = (route || '').split('?')[0].split('#')[0].trim();
    if (!value) return '/';
    return value.replace(/\/+/g, '/').replace(/\/$/, '') || '/';
  }

  private matchesRoutePattern(route: string, pattern: string): boolean {
    const routeSegments = this.splitRoute(route);
    const patternSegments = this.splitRoute(pattern);
    return this.matchSegments(routeSegments, patternSegments);
  }

  private splitRoute(route: string): string[] {
    const normalized = this.normalizeRoute(route);
    return normalized === '/' ? [] : normalized.split('/').filter(Boolean);
  }

  private matchSegments(routeSegments: string[], patternSegments: string[]): boolean {
    if (patternSegments.length === 0) {
      return routeSegments.length === 0;
    }

    const [head, ...tail] = patternSegments;

    if (head === '**') {
      if (tail.length === 0) return true;
      for (let i = 0; i <= routeSegments.length; i++) {
        if (this.matchSegments(routeSegments.slice(i), tail)) {
          return true;
        }
      }
      return false;
    }

    if (routeSegments.length === 0) return false;

    const current = routeSegments[0];
    const matchesCurrent = head === '*' || head === current;
    return matchesCurrent && this.matchSegments(routeSegments.slice(1), tail);
  }

  /**
   * Get all allowed routes for a role
   */
  getAllowedRoutesForRole(role: string): string[] {
    const roleConfig = this.roleRoutes.find(r =>
      r.role.toLowerCase() === role.toLowerCase()
    );

    return roleConfig?.allowedRoutes || [];
  }
}
